import { render, staticRenderFns } from "./ApprovalNodeConfig.vue?vue&type=template&id=ad06f428&scoped=true"
import script from "./ApprovalNodeConfig.vue?vue&type=script&lang=js"
export * from "./ApprovalNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./ApprovalNodeConfig.vue?vue&type=style&index=0&id=ad06f428&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad06f428",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad06f428')) {
      api.createRecord('ad06f428', component.options)
    } else {
      api.reload('ad06f428', component.options)
    }
    module.hot.accept("./ApprovalNodeConfig.vue?vue&type=template&id=ad06f428&scoped=true", function () {
      api.rerender('ad06f428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/process/config/ApprovalNodeConfig.vue"
export default component.exports